import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Signal, MonthlyStat, SignalStat, MonthlyStats } from '../model/signal';
import { SignalLoadListCriteria, SignalSearchCriteria, SignalStatsCriteria } from '../model/searchCriteria';
import { constants } from '../constants';
import { Utilities } from '../utilities';
import { SessionStorageItem } from '../model/shared-items';

@Injectable()
export class WorldWatchService {

    private signalURL = environment.endpoints.worldwatch;
    private signalLikeURL = environment.endpoints.worldwatch + 'like/';
    private signalPdfURL = environment.endpoints.worldwatch + 'pdf/';
    private signalSearchURL = environment.endpoints.worldwatch + 'search';
    private signalLoadListURL = environment.endpoints.worldwatch + 'loadList';
    private signalAttributeStatsURL = environment.endpoints.worldwatch + 'attributeStats';
    private signalAttributeMonthlyStatsURL = environment.endpoints.worldwatch + 'attributeMonthlyStats';

    constructor(private http: HttpClient) { }

    signal(jiraRef: string): Promise<Signal> {
      return this.http
        .get(this.signalURL + jiraRef)
        .toPromise()
        .then(response => response as Signal)
        .catch(this.handleError);
    }

    signalLike(jiraRef: string): Promise<any> {
        return this.http
            .get(this.signalLikeURL + jiraRef)
            .toPromise()
            .then(response => response as any)
            .catch(this.handleError);
    }

    signalSearch(searchQuery: SignalSearchCriteria): Promise<Signal[] | any[]> {
        return this.http
            .post(this.signalSearchURL, JSON.stringify(searchQuery))
            .toPromise()
            .then(response => response as any[])
            .catch(this.handleError);
    }

    signalLoadList(searchQuery: SignalLoadListCriteria): Promise<Signal[] | any[]> {
        return this.http
            .post(this.signalLoadListURL, JSON.stringify(searchQuery))
            .toPromise()
            .then(response => response as any[])
            .catch(this.handleError);
    }

    signalUrgencyStats(pubDateFrom: string, pubDateTo: string): Promise<SignalStat[]> {
        return this.http
            .post(this.signalAttributeStatsURL, JSON.stringify({publishDateFrom: pubDateFrom, publishDateTo: pubDateTo, attributeName: constants.fields.signals.urgency}))
            .toPromise()
            .then(response => response as SignalStat[])
            .catch(this.handleError);
    }

    signalCategoryStats(pubDateFrom: string, pubDateTo: string): Promise<SignalStat[]> {
        return this.http
            .post(this.signalAttributeStatsURL, JSON.stringify({publishDateFrom: pubDateFrom, publishDateTo: pubDateTo, attributeName: constants.fields.signals.category}))
            .toPromise()
            .then(response => response as SignalStat[])
            .catch(this.handleError);
    }

    signalMonthlyStats(searchCritera: SignalStatsCriteria): Promise<MonthlyStats[]> {
        return this.http
            .post(this.signalAttributeMonthlyStatsURL, JSON.stringify(searchCritera))
            .toPromise()
            .then(response => response as MonthlyStat[])
            .catch(this.handleError);
    }

    signalPDF(jiraRef: string): any {
        return this.http.get(this.signalPdfURL + jiraRef, {responseType: 'blob'});
    }

    signalCountSinceLastLogin(date: Date): Promise<number> {
        return new Promise((resolve,reject) => {

            if(sessionStorage.getItem(SessionStorageItem.signalsLastLoginCount)){
                resolve(Number(sessionStorage.getItem(SessionStorageItem.signalsLastLoginCount)));
            }else{
                const tempSearchCriteria = new SignalSearchCriteria();
                tempSearchCriteria.updateDateFrom = Utilities.getDateAsString(date);
                tempSearchCriteria.updateDateTo = Utilities.getToday();
                tempSearchCriteria.count = true;
                this.signalSearch(tempSearchCriteria)
                .then(res => {
                    if(res && res.length == 0){
                        sessionStorage.setItem(SessionStorageItem.signalsLastLoginCount, String(0));
                        resolve(0);
                    }else{
                        sessionStorage.setItem(SessionStorageItem.signalsLastLoginCount, String(res[0].matching_signals));
                        resolve(res[0].matching_signals);
                    }
                })
                .catch(err => {
                    reject(err);
                });
            }
        });
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}
